import { createContext } from "react";

interface defaultTabsContext {
    setChild: (child: any, index: number) => void,
    getIndex: () => number,
}

export const TabsContext = createContext<defaultTabsContext | null>(null);